import ReactDOM from "react-dom";
import "../../styles/components/csvErrorModal.css"
const CSVErrorModal = ({ errors, onClose }) => {
  return ReactDOM.createPortal(
    <div className="csv-overlay" onClick={onClose}>
      <div className="csv-modal" onClick={(e) => e.stopPropagation()}>

        {/* Header */}
        <div className="csv-header">
          <div className="csv-icon">⚠️</div>
          <div>
            <h2>CSV Import Errors</h2>
            <p>{errors.length} row(s) failed to import</p>
          </div>
        </div>

        {/* Error List */}
        <div className="csv-error-list">
          {errors.map((err, i) => (
            <div key={i} className="csv-error-item">
              <div className="csv-error-row">Row {err.row}</div>
              <div className="csv-error-msg">{err.message}</div>
            </div>
          ))}
        </div>

        {/* Footer */}
        <div className="csv-footer">
          <button className="csv-close-btn" onClick={onClose}>
            Close
          </button>
        </div>

      </div>
    </div>,
    document.body
  );
};

export default CSVErrorModal;